<template>
  <div v-if="haveInvoice">
    <ul class="nav nav-actions">
      <li><a :href="urlToDownloadPdf" @click.prevent="downloadFile"><i class="fa fa-file-pdf-o"></i> Download PDF</a></li>
      <li><a :href="urlToDownloadArchive" id="download-archive" @click.prevent="downloadFile"><i class="fa fa-file-archive-o"></i> Download Weighbridge Archive</a></li>
    </ul>

    <div class="details-flex">
      <div class="ibox ibox-flex">
        <div class="ibox-content ibox-content-padding-xs">
          <ul class="invoice-details">
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">To:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>
                  {{ decorated.user_name }}<br />
                  {{ decorated.user_address }}<br />
                  {{ decorated.user_suburb }}, {{ decorated.user_state }}, {{ decorated.user_postcode }},<br />
                  Australia
                </p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Invoice:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>{{ decorated.xero_number}}</p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Reference:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>{{ decorated.order_reference }}</p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Issued:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>{{ decorated.created_date_alternative }}</p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Due:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>{{ decorated.due_date_alternative }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="ibox ibox-flex">
        <div class="ibox-content ibox-content-padding-xs">
          <ul class="invoice-details">
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">From:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>
                  Arrow Logistics (QLD) Pty Ltd<br />
                  ATF Forster &amp; Borrman Trust<br />
                  PO Box 4796<br />
                  Toowoomba East QLD 4350<br />
                </p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">ABN:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>52 559 308 952</p>
              </div>
            </li>

            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">ACN:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>119 008 454</p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Office:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>0455 123 172</p>
              </div>
            </li>
            <li class="row">
              <div class="col-sm-5 col-md-4">
                <p class="heading">Office:</p>
              </div>
              <div class="col-sm-7 col-md-8">
                <p>accounts@arrowlogistics.com.au</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="ibox">
      <div class="ibox-content ibox-content-padding-xs">
        <h3 class="invoice-single">Invoice Items</h3>
        <ul class="list-detail list-detail-invoice-single">
          <li>
            <router-link :to="{ name: 'jobs.show', params: { id: invoice.job.id } }">
              Job {{ decorated.job.number }}
            </router-link>
            <template v-for="load in invoice.loads">
              <invoice-invoiced-item v-for="item in load.items" :key="`load-${load.id}-item-${item.id}`" :item="item" :load="load" :user="invoice.user"></invoice-invoiced-item>
            </template>
          </li>
        </ul>

        <div class="row">
          <div class="col-xs-offset-3 col-xs-9 col-sm-offset-7 col-sm-5 col-lg-offset-8 col-lg-4">
            <ul class="invoice-totals">
              <li>
                Subtotal
                <span class="amount">{{ decorated.total_without_gst }}</span>
              </li>
              <li>
                Total GST (10%)
                <span class="amount">{{ decorated.total_gst }}</span>
              </li>
              <li class="total">
                Total AUD
                <span class="amount">{{ decorated.total_with_gst }}</span>
              </li>
              <li v-if="decorated.hasSomePayments">
                Payments
                <span class="amount">{{ decorated.paid }}</span>
              </li>
              <li class="total" v-if="decorated.hasSomePayments">
                Amount Due AUD
                <span class="amount">{{ decorated.remaining }}</span>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <div class="ibox">
      <div class="ibox-content ibox-content-padding-xs">
        <h3 class="invoice-single">Payment History</h3>

        <ul class="list-detail list-detail-payments">
          <invoice-payment-item v-for="payment in invoice.payments" :key="payment.id" :payment="payment"></invoice-payment-item>

          <li class="text-center text-muted" v-if="haveNoInvoicePayments">
            There are no payments.
          </li>
        </ul>

        <div class="row">
          <div class="col-xs-offset-3 col-xs-9 col-sm-offset-7 col-sm-5 col-lg-offset-8 col-lg-4">
            <ul class="invoice-totals">
              <li class="total">
                Total
                <span class="amount">{{ totalOfPaymentsAsMoney }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="margin-20"></div>

    <div class="row">
      <div class="col-xl-12">
        <ladda-button
          :on-click="handleSyncToXero"
          class="btn btn-sm btn-warning pull-right"
          style="margin-right: 20px;"
        >Sync To Xero</ladda-button>
      </div>
    </div>

    <div class="margin-20"></div>

    <h2>Payment Methods</h2>

    <p class="m-b-lg">
      <strong><i class="far fa-university"></i> Bank Transfer</strong><br />
      BSB: 064 446<br />
      Account: 1022 6813<br />
      Name: ARROW LOGISTICS
    </p>
  </div>
</template>
<script>
  import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
  import { RESET_INVOICE } from 'vx/mutations'
  import { sumBy, split } from 'lodash'
  import { url, notify } from 'utils'
  import InvoicePaymentItem from './InvoicePaymentItem'
  import InvoiceInvoicedItem from './InvoiceInvoicedItem'
  import accounting from 'accounting'
  import { LaddaButton } from 'components/forms'
  import Notify from '@/utils/notify'

  export default {
    components: {
      LaddaButton,
      InvoicePaymentItem,
      InvoiceInvoicedItem
    },

    created () {
      this[RESET_INVOICE]()

      this.getInvoice(this.$route.params.id).then(this.automaticallyDownloadInvoiceOrDockets)
    },

    beforeDestroy () {
      this[RESET_INVOICE]()
    },

    computed: {
      ...mapGetters('invoice', {
        decorated: 'invoiceDecorated',
        haveInvoice: 'haveInvoice'
      }),
      ...mapState('invoice', ['invoice']),

      haveNoInvoicePayments () {
        return this.invoice.payments.length === 0
      },

      totalOfPaymentsAsMoney () {
        return accounting.formatMoney(sumBy(this.invoice.payments, 'amount_paid'))
      },

      urlToDownloadArchive () {
        return url(`invoices/${this.invoice.id}/weighbridge-archive`)
      },

      urlToDownloadPdf () {
        return url(`invoices/${this.invoice.id}/pdf`)
      }
    },

    methods: {
      ...mapActions('invoice', ['getInvoice', 'syncInvoice']),
      ...mapMutations('invoice', [RESET_INVOICE]),

      handleSyncToXero () {
        return this.syncInvoice(this.invoice.id)
          .then(() => {
            notify.success('Invoice will be synced to Xero soon.')
          })
      },

      /**
       * Automatically download the invoices PDF or weighbridge dockets.
       *
       * @return void
       */
      automaticallyDownloadInvoiceOrDockets () {
        this.$nextTick(() => {
          if (this.$route.params.action) {
            if (this.$route.params.action === 'download-weighbridge-archive') {
              window.location.assign(this.urlToDownloadArchive)
            }

            this.$router.replace({ name: 'invoices.show', params: { id: this.invoice.id } })
          }
        })
      },

      downloadFile (event) {
        const noty = Notify.success('File generating...')
        noty.setTimeout(false) // make notification stay there

        const oldHref = split(event.target.href, '?', 1) // get the original url without token

        this.$http.get('auth').then(response => {
          event.target.href = `${oldHref}?token=${response.data}` // update url with latest token
          noty.close()
          window.location.href = event.target.href // download file
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Show.vue?3f4b52b5